import { TranslatePipe } from '../../filters/translate.pipe';
import { CardEmployeeSurveysComponent } from '../../components/card-employee-surveys/card-employee-surveys.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PanelDirective } from '../../directives/panel.directive';
import RoutingService from '../../services/routing.service';
import { ActivatedRoute } from "@angular/router";

@Component({
	standalone: true,
	selector: 'create-employee-surveys',
	templateUrl: './create-employee-surveys.component.html',
	imports: [ CommonModule, TranslatePipe, CardEmployeeSurveysComponent, PanelDirective ]
})
export default class CreateEmployeeSurveysView implements OnInit {
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	
	constructor(private route: ActivatedRoute) {
		this.vm = this;
	}
	
		ngOnInit() {
			this.routingService.validateAccess('employees').then(() => {});
			this.vm.surveyCode = this.route.snapshot.paramMap.get('questionnaireCode');
			this.vm.pulseContext = this.route.snapshot.queryParams || {};
		}
	
}
